module.exports = __webpack_public_path__ + "img/28.89106299.jpeg";